// extracted by mini-css-extract-plugin
export default {"main":"SubscBtn_main__3fjDE"};